import React, { useEffect, useRef } from 'react';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // Import tippy.css for default styling

const Tooltip = ({ content, children, options }) => {
  const tooltipRef = useRef();

  useEffect(() => {
    const instance = tippy(tooltipRef.current, {
      content,
      ...options,
    });

    return () => {
      instance.destroy();
    };
  }, [content, options]);

  return <span ref={tooltipRef}>{children}</span>;
};

export default Tooltip;